//Notify
export const apiUpdateDomainForAI = "/aimanager/api/v1/UpdateDomainForAI"
export const apiGetDomain = "/aimanager/api/v1/GetDomain"
export const apiGetHistories = "/aimanager/api/v1/GetHistories"
export const apiGetChatBotInfo = "/aimanager/api/v1/GetChatBotInfo"
export const apiUpdateAvatarAndChatBotName = "/aimanager/api/v1/UpdateAvatarAndChatBotName"
export const apiGetScriptLink = "/aimanager/api/v1/GetScriptLink"
export const apiRequestTraining = "/aimanager/api/v1/RequestTraining"
